import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Side - Image and Header */}
          <div className="lg:sticky lg:top-24">
            <div className="text-left mb-8">
              <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">FAQs</span>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-4">
                Frequently Asked <span className="text-orange-600">Questions</span>
              </h2>
              <p className="text-xl text-gray-600">
                Get answers to common questions about our construction services
              </p>
            </div>

            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg"
                alt="FAQ"
                className="w-full h-96 object-cover"
              />
            </div>
          </div>

          {/* Right Side - Accordion */}
          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-slate-50 rounded-xl px-6 border-none"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-orange-600 hover:no-underline py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 pb-6 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;